import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import DatabaseProvider from "@nozbe/watermelondb/DatabaseProvider";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { database } from "./model/database";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <DatabaseProvider database={database}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </DatabaseProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
